module.exports = __webpack_public_path__ + "static/img/bank.e470299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank.png
// module id = P54z
// module chunks = 0